import NoAuditModal from 'app/components/NoAuditModal'
import {AuditPageTitle} from '../../../_metronic/layout/core/AuditPageData'
import Audit from './Audit'
import {useAuth} from 'app/modules/auth'
import {useEffect, useMemo, useState} from 'react'
import {useBlurContext} from 'app/Hooks/useBlurContext'
import {collection, doc, onSnapshot} from 'firebase/firestore'
import db from 'services/firebase'

const AuditWrapper = () => {
  const {currentUser, logout} = useAuth()
  const [audits, setAudits] = useState<any[]>([])
  const [showNoAuditModal, setShowNoAuditModal] = useState(false)
  const {setBlurred} = useBlurContext()
  const [users, setUsers] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const tenantId = currentUser?.tenantId || ''
    if (!tenantId) {
      return
    }
    const tenantRef = doc(db, 'tenants', tenantId)
    const PolicyRef = collection(tenantRef, 'audits')

    const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
      let Data = snapshot.docs
        .map((doc) => ({
          ...doc.data(),
          id: doc.id,
          status: doc.data()?.status,
          createdAt: doc.data().createdAt,
          auditor: doc.data().auditor, 
        }))
        .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())

      if (currentUser?.role === 'Auditor') {
        Data = Data.filter((audit) => {
          if (!audit.auditor) return false
          if (Array.isArray(audit.auditor)) {
            const hasAccess = audit.auditor.some(auditor => 
              auditor.id === currentUser?.uid || auditor.email === currentUser?.email
            )
            return hasAccess
          } else {
            return audit.auditor.id === currentUser?.uid
          }
        })
      }
      setAudits(Data)
      setIsLoading(false)
    })

    return unsubscribe
  }, [])

  useEffect(() => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const PolicyRef = collection(tenantRef, 'employees')

      const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
        const risksData = snapshot.docs
          .map((doc) => ({
            ...doc.data(),
            id: doc.id,
            role: doc.data().role,
          }))
          .filter((item) => item.role === 'Owner')

        setUsers(risksData)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting personnels:', error)
    }
  }, [])

  const activeAudit = useMemo(() => {
    return audits.filter((audit) => audit.status !== 'Completed')
  }, [audits])

  useEffect(() => {
    // Only run blur logic after data has been loaded
    if (isLoading) {
      return
    }

    const shouldBlur = currentUser?.role === 'Auditor' && activeAudit.length <= 0
    setBlurred(shouldBlur)

    if (currentUser?.role === 'Auditor' && activeAudit.length <= 0) {
      setShowNoAuditModal(true)
    } else {
      setShowNoAuditModal(false)
    }

    return () => {
      setBlurred(false)
      setShowNoAuditModal(false)
    }
  }, [currentUser?.role, activeAudit.length, setBlurred, isLoading])

  return (
    <>
      <NoAuditModal
        isOpen={showNoAuditModal}
        onClose={() => setShowNoAuditModal(false)}
        onLogout={logout}
        users={users}
      />
      <AuditPageTitle
        icon='Audits-icon.svg'
        title='Audits'
        desc={'Track and manage your security audits in one centralized view'}
      />
      <Audit />
    </>
  )
}

export default AuditWrapper
